// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"4fdcc955","52":"f7e5c2bb","167":"d528c19c","175":"559e6b99","239":"d556a501","297":"d368bcc3","326":"8a7f3ffd","334":"91c9d071","411":"da292ba5","455":"ea51fbf6","523":"5581a4f4","647":"551fe3b9","688":"2b675351","781":"198ec92c","976":"be43fa20","977":"8a695771"}[chunkId] + ".chunk.js";
};